import { ApiContext, apiContextFetch } from "@/hooks/api/base"

// Action Link types
export interface ActionLinkProperties {
  // Automation handoff
  title?: string
  prompt?: string

  // Email draft
  syncbox_draft_id?: string
  household_id?: string

  // Create task
  taskable_type?: "Household" | "Contact" | "Business"
  taskable_id?: string | number

  // Modify record
  endpoint?: string
  http_method?: string
  params?: Record<string, unknown>
  invalidate_queries?: string[][]

  // Start project
  form_responses?: Record<string, string | number | boolean | null>

  description?: string
  max_sources?: number
  sources?: Array<{ id: string; name: string; details?: string[] }>

  [key: string]: unknown
}

export interface ActionLink {
  id: string
  type: string
  expires_at: string
  executed_at?: string
  executed_by_id?: string
  properties?: ActionLinkProperties
  executable?: boolean
  deliverable_id?: string | null
  download_url?: string | null
  preview_url?: string | null
  deliverable_status?:
    | "pending"
    | "extracting"
    | "rendering"
    | "ready"
    | "failed"
    | "normalizing"
    | "building"
    | "draft"
}

export interface ActionLinkExecutionResult {
  endpoint?: string
  http_method?: string
  params?: Record<string, unknown>
  invalidate_queries?: string[][]
  [key: string]: unknown
}

export interface ActionLinkExecutionInput {
  name?: string
  assigned_to_id?: string | null
  assigned_team_id?: string | null
  due_date?: string
  form_responses?: Record<string, string | number | boolean | null>
  source_ids?: string[]
}

// Action Link API functions
export function fetchActionLink(context: ApiContext, id: string): Promise<ActionLink> {
  return apiContextFetch<ActionLink>(context, `action_links/${id}`)
}

export function executeActionLink(
  context: ApiContext,
  id: string,
  input?: ActionLinkExecutionInput
): Promise<{ data: ActionLinkExecutionResult }> {
  return apiContextFetch<{ data: ActionLinkExecutionResult }>(context, `action_links/${id}/execute`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ input }),
  })
}

export function performActionLinkRequest(
  context: ApiContext,
  method: string,
  endpoint: string,
  data?: Record<string, unknown>
): Promise<unknown> {
  const options: RequestInit = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
  }

  if (data && method !== "GET") {
    options.body = JSON.stringify(data)
  }

  return apiContextFetch(context, endpoint.startsWith("/") ? endpoint.slice(1) : endpoint, options)
}
